<mat-card class="p-0" (click)="open('p2p-info')">
	<div class="card-body cursor-pointer">
		<div class="d-flex justify-content-between align-items-center">
			<div>
				<img
					src="{{ helpersService.pathImgsMarkers }}/ftth.png?v={{ assets_version }}"
					alt="FTTH"
					class="img-ftth mr-2"
				/>
				<span>{{ "SERVICES_MENU.POINT_TO_POINT" | translate }}</span>
			</div>
		</div>
	</div>
</mat-card>

<div id="p2p-info" class="modal fade">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title">{{ "SERVICES_MENU.POINT_TO_POINT" | translate }}</h4>
				<button type="button" class="close" aria-label="Close" data-dismiss="modal">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<app-catalog-p2p [isFromModal]="true" [buildingType]="buildingType" (checkBea)="checkBea()">
					<p>
						<a href="javascript:void(0)" (click)="goTpP2P()">
							{{ "POINT_TO_POINT.CHECK_FEASIBILITY" | translate }}
						</a>
					</p>
				</app-catalog-p2p>
				<p class="mx-3 px-4">
					<a href="javascript:void(0)" (click)="goTpP2P()">
						{{ "POINT_TO_POINT.CHECK_FEASIBILITY" | translate }}
					</a>
				</p>
			</div>
		</div>
	</div>
</div>
